import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';
import { IOtpRequest, IOtpResponse } from '../../../core/models/otp.model';
import {
  loadForgotPasscodeLoginConfirms,
  loadForgotPasscodeLoginConfirmsSuccess,
  loadForgotPasscodeLoginConfirmsFailure
} from '../actions/forgot-passcode-login-confirm.actions';

export const forgotPasscodeLoginConfirmFeatureKey = 'forgotPasscodeLoginConfirm';

export interface ForgotPasscodeLoginConfirmState {
  isLoading: boolean;
  forgotPasscodeLoginConfirmRequest: IOtpRequest;
  forgotPasscodeLoginConfirmResponse: IOtpResponse;
  forgotPasscodeLoginConfirmFailure: IGenericError<ErrorResponse>;
}

export const initialState: ForgotPasscodeLoginConfirmState = {
  isLoading: false,
  forgotPasscodeLoginConfirmRequest: undefined,
  forgotPasscodeLoginConfirmResponse: undefined,
  forgotPasscodeLoginConfirmFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadForgotPasscodeLoginConfirms, (state, action) => ({
    ...state,
    forgotPasscodeLoginConfirmRequest: action.request,
    isLoading: true
  })),

  on(loadForgotPasscodeLoginConfirmsSuccess, (state, action) => ({
    ...state,
    forgotPasscodeLoginConfirmResponse: action.response,
    isLoading: false
  })),

  on(loadForgotPasscodeLoginConfirmsFailure, (state, action) => ({
    ...state,
    forgotPasscodeLoginConfirmFailure: action.error,
    isLoading: false
  }))
);

export const getForgotPasscodeLoginConfirmRequest = (state: ForgotPasscodeLoginConfirmState) => state.forgotPasscodeLoginConfirmRequest;
export const getForgotPasscodeLoginConfirmResponse = (state: ForgotPasscodeLoginConfirmState) => state.forgotPasscodeLoginConfirmResponse;
export const getForgotPasscodeLoginConfirmFailure = (state: ForgotPasscodeLoginConfirmState) => state.forgotPasscodeLoginConfirmFailure;
export const getForgotPasscodeLoginConfirmIsLoading = (state: ForgotPasscodeLoginConfirmState) => state.isLoading;
